import objectPath from 'object-path'
import { MATH_SYMBOLS } from 'designer/component/system/menu/condition/component/calculate/config'

const checkValue = (formula, formulaValue, testValue, formData) => {
  let { data = [], symbol } = formula
  let valueList = []
  data.forEach((item, dataIndex) => {
    let nextValue = 0
    let { isElement, isDynamic, isCustom, isSymbol, isFormula } = item || {}
    if (isSymbol) {
      nextValue = checkValue(item, nextValue, testValue)
    } else if (isDynamic) {
      let { value } = item
      nextValue = objectPath.get(testValue, value)
    } else if (isElement) {
      let { key } = item
      nextValue =
        objectPath.get(testValue, key) || objectPath.get(formData, key)
    } else if (isCustom) {
      nextValue = item.value
    } else if (isFormula) {
      nextValue = checkValue(item, nextValue, testValue)
    }
    if (nextValue === undefined) {
      nextValue = 0
    } else {
      nextValue = Number(nextValue)
    }
    valueList.push({
      item,
      nextValue,
    })
    if (dataIndex === 0) {
      formulaValue = nextValue
    } else {
      if (nextValue === undefined) {
        nextValue = 0
      }
      let nextSymbol = objectPath.get(symbol, dataIndex - 1)
      let foundSymbol = MATH_SYMBOLS.find((math) => math.symbol === nextSymbol)
      if (foundSymbol) {
        let { calculate } = foundSymbol
        formulaValue = calculate(formulaValue, nextValue)
      }
    }
  })
  return formulaValue
}

export const updateCalculate = (
  formulaData,
  formulaLink,
  dataValue,
  formData
) => {
  let result = 0
  if (formulaData) {
    formulaData.forEach((formula, formulaIndex) => {
      let formulaValue = 0
      formulaValue = checkValue(formula, formulaValue, dataValue, formData)
      if (formulaValue === undefined) {
        formulaValue = 0
      }
      if (formulaIndex === 0) {
        result = formulaValue
      } else {
        let symbol = objectPath.get(formulaLink, formulaIndex - 1)
        let foundSymbol = MATH_SYMBOLS.find((math) => math.symbol === symbol)
        if (foundSymbol) {
          let { calculate } = foundSymbol
          result = calculate(result, formulaValue)
        }
      }
    })
  } else {
    result = 0
  }
  return Math.round(result * 100) / 100
}
